var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTraceliumConnectLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.9971 0C22.2079 0 24 1.79214 24 4.00286V19.9971C24 22.2079 22.2079 24 19.9971 24H4.00286C1.79214 24 0 22.2079 0 19.9971V4.00286C0 1.79214 1.79214 0 4.00286 0H19.9971ZM18.8571 15.1648V8.93143L15.0686 5.14286L8.83516 5.14286C8.83516 6.99999 10.3407 8.50549 12.1978 8.50549H15.4945V11.8022C15.4945 13.6593 17 15.1648 18.8571 15.1648ZM5.14286 15.0686L5.14286 8.83517C6.99999 8.83517 8.5055 10.3407 8.5055 12.1978V15.4945H11.8022C13.6593 15.4945 15.1648 17 15.1648 18.8571L8.93143 18.8571L5.14286 15.0686Z",
    fill: "#FDBE44"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTraceliumConnectLogo);
export default __webpack_public_path__ + "static/media/tracelium-connect-logo.a50d557a4b40e7d9281ba16400c8fd18.svg";
export { ForwardRef as ReactComponent };